try {
    window.$ = window.jQuery = require('jquery');
    window.bootstrap = require('./../plugins/bootstrap/js/bootstrap.bundle.js');
    window.noUiSlider = require('./../plugins/nouislider/nouislider.min.js');
    // require('./../plugins/imagesloaded.pkgd.min.js');
    require('./../plugins/jquery.matchHeight-min.js');
    require('masonry-layout');
    require('./../plugins/select2/dist/js/select2.min.js');
    require('./../plugins/slick/slick/slick.min.js');
    require('./../plugins/slick-animation.min.js');
    require('./../plugins/bootstrap-select/dist/js/bootstrap-select.min.js');
    require('imask');
    window.Toastify = require('toastify-js');
} catch (e) {
    console.log(e);
}
